"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.confirmTemplateArchiveWithModal = void 0;
var react_1 = __importStar(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var PromptTypes_1 = require("@CommonFrontend/Prompt/PromptTypes");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var classnames_1 = __importDefault(require("classnames"));
var c = (0, BemBuilder_1.default)("template-archived-confirmation-modal");
var TemplateArchiveModalBody = function (_a) {
    var modal = _a.modal, promptsStore = _a.promptsStore, checklistComponent = _a.checklistComponent, checkboxLabel = _a.checkboxLabel, titleText = _a.titleText, explainerText = _a.explainerText, confirmText = _a.confirmText, cancelText = _a.cancelText, onConfirmClick = _a.onConfirmClick, onCancelClick = _a.onCancelClick;
    var _b = __read((0, react_1.useState)(false), 2), shouldHide = _b[0], setShouldHide = _b[1];
    var handleConfirmClick = function () {
        onConfirmClick();
        if (shouldHide) {
            promptsStore.dismissedPrompt(PromptTypes_1.PromptId.ArchivedTemplatesExplanation);
        }
        modal.closeAnyModals();
    };
    var handleCancelClick = function () {
        if (onCancelClick) {
            onCancelClick();
        }
    };
    var handleMouseDownEvent = (0, react_1.useCallback)(function (e) {
        e.nativeEvent.stopImmediatePropagation();
    }, []);
    return (react_1.default.createElement("div", { className: c(), onMouseDown: handleMouseDownEvent },
        react_1.default.createElement("div", { className: c("title") }, titleText),
        react_1.default.createElement("div", { className: c("explainer") }, explainerText),
        checklistComponent,
        react_1.default.createElement("div", { className: c("footer") },
            react_1.default.createElement(kaleidoscope_1.Button, { className: c("cancel-btn"), size: kaleidoscope_1.ButtonSize.Large, type: kaleidoscope_1.ButtonType.Secondary, onClick: handleCancelClick }, cancelText),
            react_1.default.createElement(kaleidoscope_1.Button, { className: c("confirm-btn"), size: kaleidoscope_1.ButtonSize.Large, onClick: handleConfirmClick, buttonState: kaleidoscope_1.ButtonState.Idle }, confirmText)),
        react_1.default.createElement(kaleidoscope_1.Checkbox, { item: {
                id: "dontShowAgainCheckbox",
                value: "dontShowAgainCheckbox",
                label: checkboxLabel,
            }, isSelected: shouldHide, onChange: function () { return setShouldHide(!shouldHide); } })));
};
var archivedTemplateProperties = [
    {
        icon: react_1.default.createElement(icons_1.Edit, null),
        description: "Template will still be editable",
        ticked: true,
    },
    {
        icon: react_1.default.createElement(icons_1.Page, null),
        description: "No impact on existing pages",
        ticked: true,
    },
    {
        icon: react_1.default.createElement(icons_1.NoPages, null),
        crossed_icon: react_1.default.createElement(icons_1.NoEdit, null),
        description: "New pages cannot be created from this template",
        ticked: false,
    },
    {
        icon: react_1.default.createElement(icons_1.PageCollection, null),
        description: "Preserve Collection attributes and filtering",
        ticked: true,
    },
    {
        icon: react_1.default.createElement(icons_1.Automation, null),
        description: "Automations will still run for pages already created",
        ticked: true,
    },
];
var ArchiveConfirmationChecklist = function () {
    return (react_1.default.createElement("div", { className: c("checklist") }, archivedTemplateProperties.map(function (property, index) { return (react_1.default.createElement(PropertyLineItem, { key: index, description: property.description, ticked: property.ticked, icon: property.icon })); })));
};
var PropertyLineItem = function (_a) {
    var description = _a.description, ticked = _a.ticked, icon = _a.icon;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(c("checklist-item"), "".concat(ticked ? "enabled" : "disabled")) },
        react_1.default.createElement("div", { className: c("checklist-item--icon") }, icon),
        react_1.default.createElement(kaleidoscope_1.Text, { size: "s" }, description)));
};
var confirmTemplateArchiveWithModal = function (modal, promptsStore, archiveCallback) { return __awaiter(void 0, void 0, Promise, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (promptsStore.hasDismissed(PromptTypes_1.PromptId.ArchivedTemplatesExplanation)) {
                    archiveCallback();
                    return [2, true];
                }
                return [4, modal.showSimpleModal({
                        isEscapable: true,
                        body: (react_1.default.createElement(TemplateArchiveModalBody, { modal: modal, promptsStore: promptsStore, onConfirmClick: archiveCallback, onCancelClick: modal.closeAnyModals, checkboxLabel: "Don't show when archiving again", checklistComponent: react_1.default.createElement(ArchiveConfirmationChecklist, null), confirmText: "Confirm", cancelText: "Close", titleText: "Move template to Archived?", explainerText: "When templates are archived, they will still be editable, and will not impact Pages, CRM objects, Collections or additional properties." })),
                    })];
            case 1:
                _a.sent();
                return [2];
        }
    });
}); };
exports.confirmTemplateArchiveWithModal = confirmTemplateArchiveWithModal;
